module.exports = __webpack_public_path__ + "static/img/discord.d6aaf81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/benjyfishy/discord/discord.png
// module id = +Nuf
// module chunks = 35